<app-header></app-header>
<ion-content class="gray-content-bg">
  <ion-grid [fixed]="true">
    <ion-row>
      <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
    </ion-row>
    <ion-row>
      <div data-cy="header-text" class="header-text">
        {{ 'i18n.pageTitles.aog' | translate }}
      </div>
    </ion-row>
  </ion-grid>
  <ion-grid class="iframe-grid" [fixed]="true">
    <div *ngIf="!isLoaded" class="loading-container">
      <img src="assets/images/Frying-Pan.svg" />
      <span class="first bold">One Moment Please</span>
      <span class="second medium">We're cooking up something great...</span>
    </div>

    <div *ngIf="!!iframeUrl" class="iframe-container">
      <iframe class="iframe" data-cy="iframe" [src]="iframeUrl"></iframe>
    </div>
  </ion-grid>
  <app-footer></app-footer>
</ion-content>
